// Čítanie natívneho textu dostupnosti — slovenské dvojča locale/cs/cartCrossSellModel.js
// (dev/sk/*.html: „Skladom").
export default {
  inStockRe: /^skladom/i,
};
